export const MenuRoutes = {
  1: "/dashboard",
  2: "/order/list",
  3: "/product/list",
  4: "/store/list",
  5: "/config/configuration",
  6: "/employee/list",
  7: "/reports/sales-report",
  8: "/sales-call-report/list",
  9: "/proforma-invoice/list",
  10: "/purchase-order/list",
  11: "/proforma-quote/list",
  12: "/foc/approvals",
  14: "/missing-stock/list",
};
